import testData from "@/shared/testData.js";
import { AppState, Mutations, Actions } from "@/types/entities.ts";
import AppClient from "@/store/service/appClient";

export const state: AppState = {
  sidebarOpen: true,
  information: {},
  loading: false,
};

export const mutations: Mutations = {
  toggleSidebar: (state: AppState) => {
    state.sidebarOpen =  !state.sidebarOpen;
  },
  getInformation: (state: AppState, info) => {
    state.information = info;
  },
  startLoading: (state: AppState) => {
    state.loading = true;
  },
  endLoading: (state: AppState) => {
    state.loading = false;
  },
};

const getters = {};

const actions: Actions = {
  toggleSidebar: ({commit}) => {
    commit("toggleSidebar");
  },

  getInformation: ({commit}) => {
    return new Promise( async (resolve, reject) => {
      try {
        const notifications = await AppClient.getNotifications();
        commit("getInformation", notifications);
        resolve(notifications);
      } catch (err) {
        reject(err);
      }
    });
  },

  startRequest: ({commit}) => {
    commit("startLoading");
  },

  endRequest: ({commit}) => {
    commit("endLoading");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
